import { createReducer } from 'typesafe-actions';
import { createRoutineReducers, getInitialState } from '../common/utils/routine-reducer.js';
import { getContentVersionRoutine, VIEW_CONTENT_DIFF } from './actions.js';
import type { NAME } from './constants.js';
import type { ContentVersion, VersionState } from './types.js';

export const initialContentVersionData: ContentVersion = {
  content: {},
  schema: null
};

export type VersionSlice = {
  [NAME]: VersionState;
};

export const initialState: VersionState = getInitialState(initialContentVersionData, 'loading', 'loaded');

export default createReducer<VersionState>(initialState, {
  ...createRoutineReducers(getContentVersionRoutine),
  [VIEW_CONTENT_DIFF]: (state: VersionState, { payload }: { payload: number | null }): VersionState => ({
    ...state,
    error: '',
    selectedVersion: payload,
    data: payload ? state.data : initialContentVersionData
  })
});
